export enum ProcessType {
  Update = "Updating",
  Delete = "Deleting",
  Upload = "Uploading",
  Create = "Creating",
}